import { Container, Text, Button, Title, Image, Paper, Flex, Stack, Box } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import classes from './Hero.module.css';
import React from "react";

interface HeroProps {
    callToAction: string;
    onCallToActionClick: () => void; // onClick function for call to action button
}

const Arrow = () => (
    <svg width="100%" height="100%" viewBox="0 0 222 197" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="43" width="140" height="131" fill="white"/>
        <path d="M122.586 11.6331L201.716 104.93L121.353 196.092L122.586 11.6331Z" fill="white"/>
    </svg>
);

export const Hero: React.FC<HeroProps> = ({ callToAction, onCallToActionClick }) => {
    const { width } = useViewportSize();
    const isMobile = width < 768;
    const isTablet = width >= 768 && width < 1100;

    return (
        <Box style={{ position: 'relative', overflow: 'hidden' }}>
            <Flex direction={isMobile ? "column" : "row"}>
                <Paper
                    style={{
                        backgroundColor: '#1F1E20',
                        minHeight: isMobile ? '70vh' : 'auto',
                        width: isMobile ? '100%' : '50%',
                        padding: isMobile ? '8% 5%' : '3% 5%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        paddingTop: isMobile ? '8%' : '10%'
                    }}
                >
                    <Stack gap="lg" w="100%">
                        <Box style={{ position: 'relative' }}>
                            {!isMobile ? (
                                <>
                                <Title
                                    c="white"
                                    order={1}
                                    style={{
                                        fontFamily: 'Bebas Neue',
                                        fontWeight: 700,
                                        fontStyle: 'normal',
                                        fontSize: isMobile ? 'clamp(2.5rem, 8vw, 3.5rem)' : 'clamp(3.5rem, 5vw, 7rem)',
                                        lineHeight: 1.1,
                                        marginBottom: '0.3em',
                                        wordBreak: 'break-word',
                                        letterSpacing: '0.5px',
                                        textShadow: '0px 2px 4px rgba(0,0,0,0.2)'
                                    }}
                                >
                                    ORGANIZE SCANNED <br/> PHOTOS IN <br/> MINUTES
                                </Title>
                                {/*todo: I want this arrow to be as big and obnoxious as possible without overlapping the text!*/}
                                <Box
                                    style={{
                                        position: 'absolute',
                                        bottom: '0',
                                        right: '0',
                                        width: 'clamp(80px, 15vw, 222px)',
                                        transform: 'translateX(-10%)'
                                    }}
                                >
                                    <Arrow/>
                                </Box>
                                </>
                            ) : (
                                <>
                                <Title
                                    c="white"
                                    order={1}
                                style={{
                                    fontFamily: 'Bebas Neue',
                                    fontWeight: 700,
                                    fontStyle: 'normal',
                                    fontSize: 'clamp(4rem, 12vw, 5.5rem)',
                                    lineHeight: 1.05,
                                    marginBottom: '0.1em',
                                    wordBreak: 'break-word',
                                    letterSpacing: '0.5px',
                                    textShadow: '0px 2px 4px rgba(0,0,0,0.2)'
                                }}
                            >
                                ORGANIZE SCANNED PHOTOS <br/> IN MINUTES
                            </Title>
                                </>
                                )}
                        </Box>

                        <Stack gap="xs" w={isMobile ? '100%' : 'clamp(280px, 80%, 600px)'} mt={isMobile ? '0.5rem' : 'lg'}>
                            <Text
                                c="white"
                                style={{
                                    fontSize: isMobile ? 'clamp(1.1rem, 4vw, 1.3rem)' : 'clamp(1rem, 1.5vw, 1.2rem)',
                                    lineHeight: 1.5
                                }}
                                ta="left"
                            >
                                Our AI-driven platform intelligently groups photos by events, estimates dates, and generates context-aware captions. We
                                go beyond simple digitization, offering unique insights that bring your memories to life.
                            </Text>
                            {/* <Text
                                c="white"
                                style={{
                                    fontSize: isMobile ? 'clamp(1rem, 3.5vw, 1.2rem)' : 'clamp(0.9rem, 1.3vw, 1.1rem)',
                                    lineHeight: 1.5,
                                    fontWeight: 'bold',
                                    marginTop: '0.5rem',
                                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                                    padding: '8px 12px',
                                    borderRadius: '4px'
                                }}
                                ta="left"
                            >
                                🚀 Launching May 1st, 2025! Join our waitlist for early access.
                            </Text> */}
                            <Button
                                fullWidth={isMobile}
                                variant="filled"
                                size={isMobile ? "lg" : "xl"}
                                className={classes.control}
                                mt={isMobile ? "lg" : "md"}
                                onClick={onCallToActionClick}
                                style={{
                                    alignSelf: isMobile ? 'stretch' : 'flex-start',
                                    fontSize: isMobile ? '1.1rem' : 'clamp(1rem, 1.2vw, 1.2rem)',
                                    padding: isMobile ? '10px 20px' : undefined
                                }}
                            >
                                {callToAction}
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>

                {!isMobile && (
                <Paper
                    style={{
                        backgroundColor: 'white',
                        minHeight: isMobile ? '40vh' : '100vh',
                        width: isMobile ? '100%' : '50%',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        justifyContent: 'center',
                        overflow: 'hidden'
                    }}
                >
                </Paper>
                )}
            </Flex>
            
            {/* Desktop image */}
            {!isMobile && (
                <Box
                    style={{
                        position: 'absolute',
                        width: '54%',
                        right: '3%',
                        top: '45%',
                        transform: 'translateY(-42%)',
                        zIndex: 2
                    }}
                >
                    <Image
                        src={'./HeroScreenShots.png'}
                        style={{
                            width: '100%',
                            height: 'auto'
                        }}
                    />
                </Box>
            )}
        </Box>
    );
}